import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconDrop: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.32248 0.246737C9.07552 -0.0493308 8.64153 -0.0838267 8.35311 0.169688C8.3262 0.193347 8.3011 0.219107 8.27806 0.246737C6.4642 2.42457 0.549984 9.95377 0.549984 15.531C0.549984 20.7283 3.73769 24 8.79998 24C13.8623 24 17.05 20.7283 17.05 15.531C17.05 9.95377 11.1358 2.42457 9.32248 0.246737H9.32248ZM9.71665 20.9417C9.33695 20.9426 9.02848 20.6273 9.02764 20.2375C9.02747 20.1569 9.04077 20.0768 9.06696 20.0007C9.16312 19.7155 9.42668 19.5258 9.72066 19.5302C11.6152 19.526 13.1501 17.9505 13.1541 16.0056V16.0056C13.1498 15.7038 13.3346 15.4332 13.6125 15.3345C13.9705 15.2046 14.3633 15.3972 14.4898 15.7647C14.516 15.8407 14.5293 15.9208 14.5291 16.0015V16.0013C14.5264 18.7285 12.3735 20.9387 9.71681 20.9417L9.71665 20.9417Z" />
    </svg>
  </IconStyled>
);

IconDrop.defaultProps = iconDefaultProps;
IconDrop.displayName = 'IconDrop';

export default IconDrop;
